<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-06 13:53:17
 * @FilePath: /mrc-ess-fronted/src/Page/EssAdmin/Announcement/Announcement.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-18 15:39:16
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_Announcement_list_title')"
    pad="0"
    :addBtn="hasBtn('add-company-announcement')"
    @new="onNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber
        contentBackground="transparent"
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
      >
        <template v-slot:content-1>
          <Tabler
            :headers="headers"
            :height="$vuetify.breakpoint.height - 335"
            :items="desserts1"
            border
            :totalCount="totalCount1"
            @change="
              (page, perpage, callback) => {
                getList(1, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.title="{ item }">
              <div
                class="text--primary table-title"
                :title="$getCommonLangValue(item.message_title)"
              >
                {{ $getCommonLangValue(item.message_title) }}
              </div>
            </template>
            <template v-slot:item.publicDate="{ item }">
              <div class="text--primary table-title">
                {{
                  $getDateTime(item.send_start_utc_datetime, "YYYY/MM/DD HH:mm")
                }}
              </div>
            </template>
            <template v-slot:item.endDate="{ item }">
              <div class="text--primary table-title">
                {{
                  $getDateTime(item.send_end_utc_datetime, "YYYY/MM/DD HH:mm")
                }}
              </div>
            </template>
            <template v-slot:item.force_reply="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <svg-icon
                      size="24"
                      v-if="Number(item.is_confirm_read)"
                      fill="transparent"
                      iconClass="Done"
                    />
                    <span class="material-icons-round text--secondary" v-else>
                      cancel
                    </span>
                  </div>
                </template>
                {{ $getCommonLangValue(item.send_status_detail) }}
              </v-tooltip>
            </template>
            <template v-slot:item.readed="{ item }">
              <div class="text--primary table-title">
                {{ item.read_num }}/{{ item.total }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid)"
                v-if="hasBtn('view-company-announcement')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :items="desserts2"
            border
            :height="$vuetify.breakpoint.height - 335"
            :totalCount="totalCount2"
            @change="
              (page, perpage, callback) => {
                getList(0, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.title="{ item }">
              <div
                class="text--primary table-title"
                :title="$getCommonLangValue(item.message_title)"
              >
                {{ $getCommonLangValue(item.message_title) }}
              </div>
            </template>
            <template v-slot:item.publicDate="{ item }">
              <div class="text--primary table-title">
                {{
                  $getDateTime(item.send_start_utc_datetime, "YYYY/MM/DD HH:mm")
                }}
              </div>
            </template>
            <template v-slot:item.endDate="{ item }">
              <div class="text--primary table-title">
                {{
                  $getDateTime(item.send_end_utc_datetime, "YYYY/MM/DD HH:mm")
                }}
              </div>
            </template>
            <template v-slot:item.force_reply="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <svg-icon
                      size="24"
                      v-if="Number(item.is_confirm_read)"
                      fill="transparent"
                      iconClass="Done"
                    />
                    <span class="material-icons-round text--secondary" v-else>
                      cancel
                    </span>
                  </div>
                </template>
                {{ $getCommonLangValue(item.send_status_detail) }}
              </v-tooltip>
            </template>
            <template v-slot:item.readed="{ item }">
              <div class="text--primary table-title">
                {{ item.read_num }}/{{ item.total }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid, 1)"
                v-if="hasBtn('view-company-announcement')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-3>
          <Tabler
            :headers="headers"
            :items="desserts3"
            border
            :totalCount="totalCount3"
            :height="$vuetify.breakpoint.height - 335"
            @change="
              (page, perpage, callback) => {
                getList(2, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.title="{ item }">
              <div
                class="text--primary table-title"
                :title="$getCommonLangValue(item.message_title)"
              >
                {{ $getCommonLangValue(item.message_title) }}
              </div>
            </template>
            <template v-slot:item.publicDate="{ item }">
              <div class="text--primary table-title">
                {{
                  $getDateTime(item.send_start_utc_datetime, "YYYY/MM/DD HH:mm")
                }}
              </div>
            </template>
            <template v-slot:item.endDate="{ item }">
              <div class="text--primary table-title">
                {{
                  $getDateTime(item.send_end_utc_datetime, "YYYY/MM/DD HH:mm")
                }}
              </div>
            </template>
            <template v-slot:item.force_reply="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <svg-icon
                      size="24"
                      v-if="Number(item.is_confirm_read)"
                      fill="transparent"
                      iconClass="Done"
                    />
                    <span class="material-icons-round text--secondary" v-else>
                      cancel
                    </span>
                  </div>
                </template>
                {{ $getCommonLangValue(item.send_status_detail) }}
              </v-tooltip>
            </template>
            <template v-slot:item.readed="{ item }">
              <div class="text--primary table-title">
                {{ item.read_num }}/{{ item.total }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid, 2)"
                v-if="hasBtn('view-company-announcement')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
  </ContentLayout>
</template>
  
<script>
export default {
  name: "Announcement",
  data() {
    return {
      iSEdited: false,
      curTab: "tab-1",
      totalCount1: 0,
      totalCount2: 0,
      totalCount3: 0,
      desserts1: [],
      desserts2: [],
      desserts3: [],
      taber: [
        "label_essweb_Announcement_list_tab_activeLabel",
        "label_essweb_Announcement_list_tab_pendingLabel",
        "label_essweb_Announcement_list_tab_unActiveLabel",
      ],
      headers: [
        {
          text: "label_essweb_Announcement_list_announcementTitleLabel",
          value: "title",
          align: "start",
          mrcSelected: false,
          sortable: false,
        },
        {
          text: "label_essweb_Announcement_list_publicDateLabel",
          value: "publicDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_Announcement_list_endDateLabel",
          value: "endDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_Announcement_list_forcedReplyLabel",
          value: "force_reply",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_Announcement_list_readedNumberLabel",
          value: "readed",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
    this.getList(0, this.$tableSetting.perPageSize, null);
    this.getList(2, this.$tableSetting.perPageSize, null);
  },
  methods: {
    onNew() {
      this.$toPage("/admin/company-announcement/add", {});
    },
    toView(uuid, status) {
      if (!status) this.$toPage("/admin/company-announcement/detail/" + uuid);
      if (status == 1) this.$toPage("/admin/company-announcement/edit/" + uuid);
      if (status == 2)
        this.$toPage("/admin/company-announcement/detail/" + uuid);
    },
    getList: function (status, page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/get-list/",
        data: {
          send_status: status,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        switch (status) {
          case 0:
            //有效和待定交换顺序 testlg lsj
            that.desserts2 = res.data;
            that.totalCount2 = res.totalcount;
            callback ? callback() : null;
            break;
          case 1:
            //有效和待定交换顺序 testlg lsj
            that.desserts1 = res.data;
            that.totalCount1 = res.totalcount;
            callback ? callback() : null;
            break;
          case 2:
            that.desserts3 = res.data;
            that.totalCount3 = res.totalcount;
            callback ? callback() : null;

            break;
          default:
            break;
        }
      });
    },
  },
};
</script>
  
 